function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomPalaceViewFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.133 3.07a1 1 0 011-1h25.733a1 1 0 011 1v25.86a1 1 0 01-1 1H3.133a1 1 0 01-1-1V3.07zm2 1v23.86h23.733V4.07H4.133z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10v6H9v-6h6zm-4 4h2v-2h-2v2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 10v6H13v-6h11zm-9 4h7v-2h-7v2zM19 6v2h-7V6h7z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 15v8h-2v-8h2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 17v2H6v-2h20zM8 19v4H6v-4h2zM26 19v4h-2v-4h2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 22v2H6v-2h20z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.996 23.09c-.089.981-.355 2.464-.886 3.733-.265.634-.621 1.276-1.104 1.773-.496.51-1.167.904-2.006.904v-2c.16 0 .344-.064.572-.299.241-.248.479-.637.693-1.15.427-1.021.661-2.289.739-3.142l1.992.182zM24.004 23.09c.089.981.355 2.464.886 3.733.265.634.621 1.276 1.104 1.773.496.51 1.167.904 2.006.904v-2c-.16 0-.344-.064-.572-.299-.241-.248-.479-.637-.693-1.15-.427-1.021-.661-2.289-.739-3.142l-1.992.182zM18 12v2h-2v-2h2zM19 19v3h-2v-3h2zM21 12v2h-2v-2h2zM22 19v3h-2v-3h2zM12.922 6.613a1 1 0 00-1.844.774 14.082 14.082 0 001.741 3.026c.306.398.624.753.93 1.019.153.132.323.26.506.361.169.093.43.207.745.207h1v-2h-.842a1.596 1.596 0 01-.098-.08 5.145 5.145 0 01-.655-.726 12.08 12.08 0 01-1.483-2.58zM19.873 6.512a1 1 0 00-1.746.976 10.257 10.257 0 002.982 3.332c.523.37 1.04.657 1.515.855.456.19.94.325 1.376.325h1v-2h-1c-.063 0-.268-.03-.608-.172a5.928 5.928 0 01-1.126-.639 8.258 8.258 0 01-2.393-2.677z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.087 6.59a1.001 1.001 0 011.826.82c-.659 1.47-1.545 2.585-2.4 3.343a6.354 6.354 0 01-1.258.886C8.876 11.835 8.433 12 8 12H7v-2h1c-.033 0 .074-.001.333-.136.235-.122.53-.32.854-.607.645-.573 1.359-1.458 1.9-2.666zM23.945 14.673a1 1 0 00-1.89.654c.544 1.572 1.222 2.534 1.99 3.083.795.567 1.548.59 1.955.59h1v-2h-1c-.268 0-.51-.015-.793-.218-.31-.22-.794-.759-1.262-2.11zM9.092 14.581a1 1 0 011.816.838c-.745 1.613-1.654 2.55-2.605 3.058C7.359 18.982 6.492 19 6 19H5v-2h1c.408 0 .865-.02 1.36-.285.486-.26 1.127-.824 1.732-2.134z",
    fill: props.color
  }));
}

export default SvgIconRoomPalaceViewFilled;